<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="File Text" class="d-icon d-icon--file-text" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 10V2A1.5 1.5 0 0 1 3 .5h4v.001a1.699 1.699 0 0 1 1.205.498L10 2.793h-.001A1.702 1.702 0 0 1 10.5 4v6A1.5 1.5 0 0 1 9 11.5H3A1.5 1.5 0 0 1 1.5 10ZM8 8a.5.5 0 0 1 0 1H4a.5.5 0 0 1 0-1h4Zm0-2a.5.5 0 0 1 0 1H4a.5.5 0 0 1 0-1h4ZM5 4a.5.5 0 0 1 0 1H4a.5.5 0 0 1 0-1h1Zm4.291-.5L7.5 1.709V3.5h1.791ZM2.5 10a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V4.5h-2a1 1 0 0 1-1-1v-2H3a.5.5 0 0 0-.5.5v8Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconFileText',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
